<template>
    <div class="">
        <button class="btn btn-primary" type="button" name="quickLetter" v-on:click="$refs['letterSelectModal'].open(), loadTemplates()">Quick Letter</button>
        <modal ref="letterSelectModal">
            <div slot="header" class="row">
                <h3 class="pull-left align-bottom">Quick Letter</h3>
                <button class="btn pull-right" v-on:click="$refs['letterSelectModal'].close()">X</button>
            </div>
            <div slot="body">
                <loader v-if="isLoading" />
                <div v-if="!isLoading">
                  <v-client-table :data="letterTemplateList" :columns="gridSpec.columns" :options="gridSpec.options">
                    <template slot="preview" slot-scope="props">
                      <div style="text-align: center;">
                          <a class="fa fa-file-text-o" style="font-size: 18px;" v-on:click="getLetterPreview(props.row)"></a>
                      </div>
                    </template>
                  </v-client-table>
                </div>
            </div>
            <div slot="footer" class="">
                <div class="row">
                    <button class="btn btn-primary col-md-3" type="button" name="cancel" v-on:click="$refs['letterSelectModal'].close(), closeLetterAlert()">Close</button>
                </div>
            </div>
        </modal>
        <vmodal ref="letterPreviewModal"
            :draggable="true"
            :adaptive="true"
            :scrollable="true"
            name="letterPreview"
            title="Letter Body Preview"
            height="auto"
            :minHeight="720"
            width="90%"
            :maxWidth="840">
            <div style="margin-top: 10px; margin-bottom: 10px; margin-left: 10px; margin-right: 10px; align-items: center;">
                <div slot="top-right" style="text-align: end">
                    <button v-on:click="$modal.hide('letterPreview'), closeLetterAlert()">X</button>
                </div>
                <h3 style="text-align: start;">Letter Body Preview</h3>
                <div>
                    <loader v-if="isLoading" />
                    <div v-if="!isLoading">
                        <editor id="editor" v-model="editor.content" :init="editor.options"></editor>
                    </div>
                    <div style="margin-top: 10px; width: 99%;">
                        <div class="alert alert-success alert-dismissible" v-bind:class="{ 'hidden' : letterAlertHidden }" role="alert">
                            <button type="button" class="close" v-on:click="closeLetterAlert()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            Letter is being generated.  It will be downloaded to your browser's Downloads folder in a few moments.
                            You will also find the letter saved in the Auto-Generated Letters section.
                        </div>
                    </div>
                </div>
                <div>
                    <div style="margin-left:10px; margin-right:10px" class="row">
                        <button type="button" class="btn btn-primary col-sm-3" v-on:click="generateLetter">Generate Letter</button>
                        <button class="btn btn-primary col-sm-3 pull-right" type="button" name="cancel" v-on:click="$modal.hide('letterPreview'), closeLetterAlert()">Close</button>
                    </div>
                </div>
            </div>
        </vmodal>
    </div>
</template>

<script>

import loggingService from '../services/util/loggingService'
import letterTemplateService from '../services/letterTemplateService'
import mediaService from '@/services/mediaService'

import loader from '@/components/Loader.vue'
import modal from '@/components/Modal.vue'
import editor from '@tinymce/tinymce-vue'

export default {
    components: {
        modal,
        loader,
        editor

    },
    props: {
        letterTemplateTypeId: { default: null },
        projectId: { default: null },
        fieldWorkRequestId: { default: null },
        fileSearchId: { default: null },
        investigationId: { default: null },
        siteNumberRequestId: { default: null },
        culturalResourceRecordingId: { default: null },
        isolateId: { default: null },
        buildingSurveyId: { default: null },
        undertakingId: { default: null },
        moaId: { default: null },
        paId: { default: null },
        e106complianceId: { default: null },
        parentId: { default: null },
        mediaTypeId: { default: null }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            letterTemplateList: [],
            gridSpec: {
                columns: ['preview', 'templateName'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 8,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        templateName: 'Template Name',
                        preview: 'Preview Letter'
                    },
                    orderBy: {
                        ascending: true,
                        column: 'templateName'
                    }
                }
            },
            editor: {
                options: {
                    selector: '#editor',
                    height: 480,
                    plugins: 'lists paste table',
                    oninit: 'setPlainText',
                    forced_root_block: false,
                    browser_spellcheck: true,
                    menubar: 'edit format',
                    toolbar: 'undo redo | fontselect fontsizeselect | bullist table',
                    table_default_attributes: {
                        border: '1',
                        width: '50%',
                        cellspacing: '0'
                    },
                    paste_postprocess: (plugin, args) => {
                        args.node.querySelectorAll('table').forEach(tableNode => {
                            tableNode.setAttribute('border', '1')
                            tableNode.setAttribute('cellspacing', '0')
                        })
                    },
                    content_style: 'body { font-family: Arial; }'
                },
                content: ''
            },
            letterAlertHidden: true
        }
    },
    computed: {
        generateLetterPdfDto: function () {
            return {
                letterTemplateTypeId: this.letterTemplateTypeId,
                projectId: this.projectId,
                fieldWorkRequestId: this.fieldWorkRequestId,
                fileSearchId: this.fileSearchId,
                investigationId: this.investigationId,
                siteNumberRequestId: this.siteNumberRequestId,
                culturalResourceRecordingId: this.culturalResourceRecordingId,
                isolateId: this.isolateId,
                buildingSurveyId: this.buildingSurveyId,
                undertakingId: this.undertakingId,
                moaId: this.moaId,
                paId: this.paId,
                e106complianceId: this.e106complianceId,
                pdfHtmlFileDto: {
                    baseUrl: this.$http,
                    headerHtml: '',
                    bodyHtml: '',
                    footerHtml: ''
                },
                parentId: this.parentId,
                mediaTypeId: this.mediaTypeId,
                letterTemplateId: null
            }
        }
    },
    mounted () {
        this.log('mounted')
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'QuickLetter', message)
        },
        loadTemplates () {
            var searchDto = { letterTemplateTypeId: this.letterTemplateTypeId }
            if (this.letterTemplateList < 1) {
                this.isLoading = true
                letterTemplateService.search(this.$http, searchDto).then(response => {
                    this.letterTemplateList = response.data
                    this.isLoading = false
                })
            }
        },
        getLetterPreview (template) {
            this.$refs['letterSelectModal'].close()
            this.$modal.show('letterPreview')
            this.isLoading = true
            this.generateLetterPdfDto.letterTemplateTypeId = template.letterTemplateTypeId
            this.generateLetterPdfDto.letterTemplateId = template.letterTemplateId
            this.generateLetterPdfDto.pdfHtmlFileDto.bodyHtml = template.templateBody
            letterTemplateService.letterTemplateDataFieldMerge(this.$http, this.generateLetterPdfDto).then(response => {
                this.editor.content = response.data.pdfHtmlFileDto.bodyHtml
                this.isLoading = false
            })
        },
        generateLetter () {
            this.letterAlertHidden = false
            this.generateLetterPdfDto.pdfHtmlFileDto.bodyHtml = this.editor.content
            mediaService.generateLetterPdfSave(this.$http, this.generateLetterPdfDto).then(response => {
                mediaService.saveFileToDownload(response, 'letter.pdf')
            })
        },
        closeLetterAlert () {
            this.letterAlertHidden = true
        }
    }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// QuickLetter.vue?5858182f